<template>
  <div class="home">
    <Nvabar></Nvabar>
    <!-- 走马灯 -->
    <banner />
    <!-- 电喵科技 -->
    <about />
    <!-- 关于我们 -->
    <news />
    <!-- 合作伙伴 -->
    <friends />
    <!-- 底部信息 -->
    <footbar />
  </div>
</template>

<script>
import Nvabar from "@/components/navbar/navbar.vue";
import Banner from "@/components/home/homeBanner.vue";
import About from "@/components/home/homeAbout.vue";
import News from "@/components/home/homeNews.vue";
import Friends from "@/components/home/homeFriends.vue";
import Footbar from "@/components/footbar/footbar.vue";

export default {
  name: "Home",
  metaInfo: {
    title: "官网",
    meta: [
      { name: "description", content: "江苏电喵科技公司官网，一家专注于新能源充电智能管控方案的公司" },
      { name: "keywords", content: "官网" },
      { name: "baidu-site-verification", content: "codeva-18v0utvVlJ" },
    ],
  },
  components: {
    Nvabar,
    Banner,
    About,
    News,
    Friends,
    Footbar,
  },
};
</script>

<style lang="scss" scoped>
.home_container {
  min-width: 960px;
}
</style>
